"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
const NoData_1 = __importDefault(require("./NoData"));
const SpinnerContext_1 = require("./SpinnerContext");
function Spinner({ isLoading = true, emptyText = undefined }) {
    const { data } = (0, ChartContext_1.useChartData)();
    const [checkEmpty, startCheckEmpty] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let timeout = null;
        if (!isLoading) {
            timeout = setTimeout(() => {
                startCheckEmpty(true);
            }, 500);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isLoading]);
    const getSpinner = (0, react_1.useContext)(SpinnerContext_1.spinnerContext);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [isLoading && getSpinner(), checkEmpty && !isLoading && ((0, jsx_runtime_1.jsx)(NoData_1.default, { isEmpty: data && data.length === 0, emptyText: emptyText }))] }));
}
exports.default = Spinner;
